import * as Config from 'common/script/config'
export default class FilesGroup {
  date = ''
  year = ''
  month = ''
  localeMonthStr = ''
  day = ''
  files = []
  active = false
  selected = false
  set dateStr (val) {
    this.year = val.substring(0, 4)
    this.month = val.substring(4, 6)
    this.day = val.substring(6, 8)
    this.date = this.year + this.month + this.day
    this.localeMonthStr = Config.monthFn('en', this.month)
  }
  get dataStr () {
    return this.date
  }
  isSameDay = function (date) {
    var dateStr = date.split('-').join('')
    if (dateStr === this.date) {
      return true
    } else {
      return false
    }
  }
  selectedCounts = function () {
    var count = 0
    var allSelected = true
    for (var i = this.files.length - 1; i >= 0; i--) {
      if (this.files[i].selected) {
        count++
      } else {
        allSelected = false
      }
    }
    this.selected = allSelected
    return count
  }
  selectAll = function (flag) {
    for (var i = this.files.length - 1; i >= 0; i--) {
      this.files[i].selected = flag
    }
  }
  appendImage = function (image) {
    if (this.files.length > 0) {
      // if (this.files[0].name === image.name) {
      //   this.files.splice(1, 0, image)
      // } else {
      //   this.files.splice(0, 0, image)
      // }
      this.files.splice(0, 0, image)
    } else {
      this.files.push(image)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/model/FilesGroup.js